import { render } from "./MalaMedias.vue?vue&type=template&id=453095e5&scoped=true"
import script from "./MalaMedias.vue?vue&type=script&lang=js"
export * from "./MalaMedias.vue?vue&type=script&lang=js"

import "./MalaMedias.vue?vue&type=style&index=0&id=453095e5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453095e5"]])

export default __exports__